export function getStatus(book) {
  if (book.status) return book.status;
  if (book.wishlist)  return 'wishlist';
  if (book.exclusion) return 'abandoned';
  return 'finished';
}

export function normaliseBooksResponse(data) {
  if (Array.isArray(data))        return data;
  if (Array.isArray(data?.books)) return data.books;
  if (data?.book)                 return [data.book];
  return [];
}

export function timeAgo(date) {
  if (!date) return '';
  const days = Math.floor((Date.now() - new Date(date)) / 86400000);
  if (days === 0)  return 'Today';
  if (days === 1)  return 'Yesterday';
  if (days < 7)   return `${days}d ago`;
  if (days < 30)  return `${Math.floor(days / 7)}w ago`;
  if (days < 365) return `${Math.floor(days / 30)}mo ago`;
  return `${Math.floor(days / 365)}y ago`;
}

export function formatDate(date) {
  if (!date) return '';
  return new Date(date).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}

const COVER_PALETTES = [
  ['#2C1810','#6B3A2A'], ['#0F1923','#1E4A7A'], ['#1A0F2E','#4A1E7A'],
  ['#0D2318','#1A5C3A'], ['#1E1A0F','#5C4A1E'], ['#1A0F0F','#5C1E1E'],
  ['#0F1A1E','#1E4A5C'], ['#1E0F1A','#5C1E4A'], ['#141E0F','#3A5C1E'],
  ['#1E140F','#5C3A1E'],
];

export function coverPalette(title = '') {
  let h = 0;
  for (let i = 0; i < title.length; i++) h = (h * 31 + title.charCodeAt(i)) >>> 0;
  return COVER_PALETTES[h % COVER_PALETTES.length];
}

export function CoverArt({ book, className = '' }) {
  const [bg, accent] = coverPalette(book?.title || '');
  const initial = (book?.title || '?')[0].toUpperCase();
  if (book?.imageLink) {
    return <img src={book.imageLink} alt={book.title} className={`object-cover ${className}`} />;
  }
  return (
    <div className={`flex items-center justify-center ${className}`}
         style={{ background: `linear-gradient(145deg, ${bg}, ${accent})` }}>
      <span className="text-white/25 font-bold select-none"
            style={{ fontSize: 'clamp(1.5rem, 4vw, 2.5rem)' }}>
        {initial}
      </span>
    </div>
  );
}

export const STATUS_LABELS = {
  reading:   'Reading',
  finished:  'Finished',
  abandoned: 'Abandoned',
  wishlist:  'Want to read',
};

export const STATUS_COLORS = {
  reading:   'text-gold',
  finished:  'text-cream-muted',
  abandoned: 'text-crimson/60',
  wishlist:  'text-cream-muted',
};
